export default __webpack_public_path__ + "static/media/logout.d9d7d940.PNG";